// API paths
const API = {
  workflowTemplateAPI: "/WorkFlowTemplate/GetAllWorkFlowTemplatesByClientId",
  removeDatafromWorkflowTemplate: "/WorkFlowTemplate/DeleteWorkFlowTemplateById",
  publishWorkflowTemplate: "/WorkFlowTemplate/PublishWorkFlowTemplateById",
  addEditWorkflowTemplate: "/WorkFlowTemplate/AddUpdateWorkFlowTemplate",
  sidebarComponents: "/WorkFlowTemplate/GetAllWorkFlowLevels",

  subflowTemplateAPI: "/WorkFlowTemplate/GetAllSubWorkFlowTemplatesByClientId",
  removeDatafromSubflowTemplate: "/WorkFlowTemplate/DeleteSubWorkFlowTemplateById",
  publishSubflowTemplate: "/WorkFlowTemplate/PublishSubWorkFlowTemplateById",
  addEditSubflowTemplate: "/WorkFlowTemplate/AddUpdateSubWorkFlowTemplate",

  primaryEvents: "/WorkFlowTemplate/GetAllPrimaryEvents",
  secondaryEvents: "/WorkFlowTemplate/GetSelectedEventsByClientId",
  addUpdateSecondaryEvents: "/WorkFlowTemplate/AddPrimaryEventToSelectedEventQueue",
  publishSecondaryEvent: "/WorkFlowTemplate/PublishEventById",
  deleteSecondaryEvent: "/WorkFlowTemplate/DeleteEventById",
  getFieldValuesforAddCandInfo: "/WorkFlowTemplate/GetFieldNamesByEventId",
  creatEditSecEvents: "/WorkFlowTemplate/AddUpdateClientEventTaskFields",
  getEventDetails: "/WorkFlowTemplate/GetEventTaskFieldNamesByEventId",

  taskList: "/WorkFlowTemplate/GetUserDefinedTasksListByClientId",
  publishTask: "/WorkFlowTemplate/PublishUserDefinedTaskById",
  deleteTask: "/WorkFlowTemplate/DeleteUserDefinedTaskById",
  addUpdateTask: "/WorkFlowTemplate/AddUpdateUserDefinedTask",
  dropdownTasks: "/WorkFlowTemplate/GetAllTasksList",
  taskParameterList: "/WorkFlowTemplate/GetTaskParametersByTaskId",

  workflowDropdownValues: "/WorkFlowTemplate/GetWorkFlowTemplateNames",
  levelDropdownValues: "/WorkFlowTemplate/GetWorkFlow_NonLevels_ByWorkflowId",
  clientDropdownValues: "/WorkFlowTemplate/clients",
  filterDropdownValues: '/WorkFlowTemplate/GetAllWorkFlowTemplateFilterFieldValues',
  departmentDropdownValues: "/WorkFlowTemplate/departments",
  previewImage: '/WorkFlowTemplate/GetWorkFlowPreviewImage',

  mailConfigurations: '/ClientMailConfiguration/GetClientMailConfigById',
  mailConfigurationDelete: '/ClientMailConfiguration/DeleteConfiguration',
  addUpdateMailConfig: '/ClientMailConfiguration/AddUpdateMailConfiguration',

  consolidatedJson: '/WorkFlowTemplate/GenerateConsolidatedWorkflow',

  toolTipDetails: '/WorkFlowTemplate/ToolTipDetails',

  addClientEventConfig: '/ClientEventConfig/AddClientEventConfig/AddClientEventConfig',
  workflowMappingJobDropdownValues: '/WorkflowMapping/GetAllJobs',
  workflowMappingDropdownValues: '/WorkflowMapping/GetTemplateByJobId',
  workflowGetAllInstance: '/WorkflowInstance/GetAllInstance',
  workflowAddWorkflowInstance: '/WorkflowInstance/AddWorkflowInstance',
  workflowDeleteWorkflowInstance: '/WorkflowInstance/DeleteWorkflowInstanceById',
  workflowCloneWorkflowInstance: '/WorkflowInstance/CloneWorkflowInstanceById',
  getWorkflowInstanceById: '/WorkflowInstance/GetWorkflowInstanceById',
  getNotesByTemplateId: "/WorkFlowTemplate/GetNotesByTemplateId",
  getNodeDataByTemplateId: "/WorkFlowTemplate/GetSubWorkFlowById",
  getSelectedEventsBySkillLevel: "/WorkFlowTemplate/GetSelectedEventsBySkillLevel",
  getEventTypedropdown: "/WFEvent/event-types",
  getGetApiEndPointdropdown: "/WFEvent/api-endpoints",
  addUpdateEvents: "/WFEvent/events",
  getAllRoles: "/Role/GetAllRoles",
  getWorkFlowPermissionById: "/WorkFlowTemplate/GetWorkFlowPermissionById",
  getCompletionRulesByWorkflowId: "/WorkFlowTemplate/GetCompletionRulesByWorkflowId",
  getCompletionRulesBySubflowId: "/WorkFlowTemplate/GetCompletionRulesBySubflowId",
  postAddUpdateWorkFlowPermission: "/WorkFlowTemplate/AddUpdateWorkFlowPermission",
  postAddUpdateWFCompletionRule: "/WorkFlowTemplate/AddUpdateWFCompletionRule",
  postAddUpdateSFCompletionRule: "/WorkFlowTemplate/AddUpdateSFCompletionRule",
  getDropdownVersionValues: "/WorkFlowTemplate/GetVersionByTemplateId",
  getVersionTemplateByTemplateId: "/WorkFlowTemplate/GetVersionTemplateByTemplateId",
  getDefaultTemplates: "/WorkFlowTemplate/getDefaultTemplates",
  getSelectedDefaultTemplateId: "/WorkFlowTemplate/getSelectedDefaultTemplateId",
  getEventWithOrderBy: "/WorkFlowTemplate/GetEventWithOrderBy",
  getRulesEventRule: "/WFEventRule/GetRulesEventRule",
  addUpdateEventRule: "/WFEventRule/AddUpdateEventRule",
  deleteEventRule: "/WFEventRule/DeleteEventRule",
  getConstaintsRulesEventValue: "/WorkFlowEventConstraint/GetEventConstraintAndValue",
  updateSubFlowOrder: "/WorkFlowTemplate/UpdateSubFlowOrder",  
  getCalloutNameFromConstraint: "/WFEventRule/GetCallOutNameByEventConstraintId",
  getRecruitmentEventTypes : "/WFEvent/recruitment-events",
  postAddWorkflowNote: "/WorkFlowTemplate/AddWorkflowNote",

};

export default API;
